import i18n from "i18next";
import { put, select, takeEvery } from "redux-saga/effects";

import { showMessageToast } from "components/toasts/MessageToast";
import { LOCAL_STORAGE_KEYS } from "constants/LocalStorageItems";
import { callApi } from "sagas/helpers/api";
import {
  selectOperationState,
  setError,
  setSuccess,
  startLoading,
} from "store/appSlice";
import { LocalStorage } from "utils/LocalStorage";

import * as UsersApi from "../api/Users";
import { sendProductInterest, userOperationPaths } from "./users.slice";

import type { PayloadAction } from "@reduxjs/toolkit";

import type { UUID } from "utils";

function* sendProductInterestSaga({
  payload,
}: PayloadAction<{ productName: string; userId: UUID }>) {
  const operationPath = userOperationPaths().productInterest;
  const currentState: { type: string } | undefined = yield select(
    selectOperationState(operationPath)
  );

  if (currentState?.type === "LOADING_STATE") {
    showMessageToast({
      bodyContent: "Processing of previous request in progress",
      variant: "info",
    });

    return;
  }

  yield put(startLoading(operationPath));

  try {
    yield callApi(UsersApi.sendProductInterest, {
      productName: payload.productName,
    });
    yield put(setSuccess(operationPath));
    const currentSavedItems = LocalStorage.getItem<{
      [key: string]: string[];
    }>(LOCAL_STORAGE_KEYS.requestedFeatures);

    LocalStorage.saveItem(LOCAL_STORAGE_KEYS.requestedFeatures, {
      ...currentSavedItems,
      [payload.userId]: [
        ...(currentSavedItems[payload.userId] ?? []),
        payload.productName,
      ],
    });
    showMessageToast({
      bodyContent: i18n.t(
        "Thanks for your interest in {{productName}}. One of the team will contact you soon.",
        { productName: payload.productName }
      ),
      variant: "info",
    });
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
    showMessageToast({
      bodyContent:
        "Request could not be processed. Please contact support@volt.io",
      variant: "failure",
    });
  }
}

export function* rootSaga() {
  yield takeEvery(sendProductInterest.type, sendProductInterestSaga);
}
